import React from "react";
import StaticPostLayout from "../components/StaticPostLayout";
import MapBanffNationalPark from "../components/Maps/banff-national-park";
import BanffNationalParkInfo from "../components/TripInfo/banff-national-park";

class BanffNationalPark extends React.Component {
  render() {
    return (
      <StaticPostLayout
        title="Banff National Park: 5-Day Icefields Parkway Itinerary"
        category="National Parks"
        slug="banff-national-park-itinerary"
        excerpt="Canada's oldest national park — Moraine Lake's turquoise water, the Icefields Parkway from Banff to Jasper, and the Columbia Icefield. One of the world's great road trips."
        tags={["National Parks", "Canada", "Road Trips", "Hiking", "Glaciers", "Scenic Drives"]}
        readTime="9 min read"
        mapComponent={<MapBanffNationalPark />}
        whereToStay={[
          { name: 'Fairmont Banff Springs', type: 'Iconic Castle Hotel · Banff', url: 'https://www.booking.com/searchresults.html?ss=Banff%2C+Alberta' },
          { name: 'Hotels in Canmore', type: 'Budget-Friendly · 20 min from Banff', url: 'https://www.booking.com/searchresults.html?ss=Canmore%2C+Alberta' },
          { name: 'Banff Townsite B&Bs', type: 'Charming Inns · Banff, AB', url: 'https://www.booking.com/searchresults.html?ss=Banff%2C+Alberta' },
        ]}
      >
        <BanffNationalParkInfo />
      </StaticPostLayout>
    );
  }
}

export default BanffNationalPark;
